import React, { useEffect, useState, useCallback } from 'react'
import { Wrapper } from './style'
import { action } from 'typesafe-actions'
import { useTypedSelector } from 'src/redux/root-reducer'
import useSnackbar from 'src/hooks/useSnackBar'
import {
  getMyPlanByIdAction,
  deletePlanAccountAction,
} from 'src/redux/actions/planAction'
import { useDispatch } from 'react-redux'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton, CreateButton } from 'src/components/Global/Button/Button'
import { SkeletonPlan } from 'src/components/Global/Skeletons/PlanSkeleton'
import styled from 'styled-components'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { ModalTitleText } from 'src/components/Global/Text/TitleText'
import WithdrawalModal from '../Withdrawal/WithdrawalModal'
const Progress = styled.div<{
  width?: any
}>`
  width: ${(props) => (props.width ? props.width : '10%')};
  background-color: ${({ theme }) => theme.colors.secondPrimary};
  color: ${({ theme }) => theme.colors.secondPrimary};
  opacity: 1;
  height: 5px;
`

const PlanInfo = () => {
  const params = useParams()
  const { id } = params
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getMyPlanByIdAction(id))
    dispatch(action(PlanTypes.UPDATE_PAYMENT_FORM, data))
  }, [dispatch])
  const [loading, setLoading] = useState(false)
  const plan = useTypedSelector((state) => state.userPlanReducer.getPlansById)
  console.log(plan)

  const {
    name,
    balance,
    amount_to_save,
    can_withdraw,
    can_delete,
    start_date,
    maturity_date,
    saving_frequency,
    progress,
    progress_percent,
    saving_type,
    plan_type,
    status,
  } = plan

  const data = {
    id: id,
    saving_into: name,
  }
  const sendRequest = () => {
    dispatch(action(PlanTypes.UPDATE_PAYMENT_FORM, data))
  }
  const navigate = useNavigate()

  const Loading = useTypedSelector(
    (state) => state.userPlanReducer.getPlanByIdLoading
  )

  const [automatedChecked, setautomatedChecked] = useState(
    saving_type === 'automated' ? true : false
  )
  let location = useLocation()
  const handleautomatedOnChange = () => {
    setautomatedChecked(!automatedChecked)
  }
  const handleChange = () => {
    setautomatedChecked(!automatedChecked)
  }
  const deleteItem = (e: any) => {
    e.preventDefault()
    setLoading(true)
    dispatch(deletePlanAccountAction({ id, onSuccess, onError }))
  }
  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    setTimeout(() => {
      if (plan_type === 'general') {
        navigate('/general-savings')
      }
      if (plan_type === 'target') {
        navigate('/target-savings')
      }
    }, 1000)
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Error deleting Your Plan',
      severity: 'error',
    })
  }
  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false)

  const handleWithdraw = (e: any) => {
    e.preventDefault()
    setShowWithdrawalModal(true)
  }

  const type: any = 'investment' || 'plan'

  return (
    <Wrapper>
      <div className="loading">
        {Loading && [1].map((n) => <SkeletonPlan key={n} theme="light" />)}
      </div>
      {Loading ? (
        <div className=""> </div>
      ) : (
        <>
          {plan && (
            <div>
              {can_withdraw && (
                <CreateButton className="withdraw" onClick={handleWithdraw}>
                  Withdraw
                </CreateButton>
              )}
              <WithdrawalModal
                showWithdrawalModal={showWithdrawalModal}
                setShowWithdrawalModal={setShowWithdrawalModal}
                plan={plan}
                type={type}
              />
              {/* withdraw modal Wrapper */}

              <form className="content">
                <div className="top-form">
                  <ModalTitleText>{name}</ModalTitleText>
                  <div className="slider">
                    <Progress
                      width={
                        progress_percent >= '100'
                          ? '100%'
                          : `${progress_percent}%`
                      }
                    />
                    <div className="notProgress"></div>
                  </div>
                  <div className="timeframe">
                    <p className="data-title">{balance} Saved</p>
                    <p className="data-title">{progress} days</p>
                  </div>
                  <div className="mtop">
                    <Link
                      to={`/${plan_type}-payment-amount`}
                      state={{ backgroundLocation: location }}
                      onClick={sendRequest}
                      className={can_withdraw ? 'one' : 'three'}
                    >
                      <ModalButton className="button top">Top up</ModalButton>
                    </Link>
                    {can_withdraw && (
                      <Link
                        to={
                          plan_type === 'general'
                            ? `/general-extend-date`
                            : '/target-extend-date'
                        }
                        state={{ backgroundLocation: location }}
                        onClick={sendRequest}
                        className="two"
                      >
                        <ModalButton className="button top white">
                          Extend end Date
                        </ModalButton>
                      </Link>
                    )}
                  </div>
                  <div className="timeframe">
                    <p className="data-title">Amount being saved</p>
                    <p className="data">{amount_to_save}</p>
                  </div>
                  <div className="timeframe top-data">
                    <p className="data-title">Saving Frequency</p>
                    <p className="data">{saving_frequency}</p>
                  </div>
                  <div className="timeframe top-data">
                    <p className="data-title">End Date</p>
                    <p className="data">{maturity_date}</p>
                  </div>
                  <div className="frequency">
                    <label className="container data">
                      Automate Savings
                      <input
                        type="radio"
                        checked={automatedChecked}
                        name="saving_type"
                        value={saving_type}
                        onClick={handleautomatedOnChange}
                        onChange={handleChange}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <p className="position reverse data-title">{status}</p>
                  <div className="timeframe">
                    <div className="date-start">
                      <p className="data-title">Start Date</p>
                      <h3 className="date-right data">{start_date}</h3>
                    </div>
                    {can_delete && (
                      <div>
                        <CreateButton
                          onClick={deleteItem}
                          className="delete-button"
                        >
                          {/* Delete Plan {loading && <Spinner />} */}
                          {loading ? 'Deleting...' : 'Delete Plan'}
                        </CreateButton>
                      </div>
                    )}
                  </div>
                </div>
                {automatedChecked && (
                  <Link
                    to={
                      plan_type === 'general'
                        ? `/general-automate`
                        : '/target-automate'
                    }
                    state={{ backgroundLocation: location }}
                    className="saveings"
                  >
                    <ModalButton className="button">
                      Click here to automate your savings
                    </ModalButton>
                  </Link>
                )}
              </form>
            </div>
          )}
        </>
      )}
    </Wrapper>
  )
}

export { PlanInfo }
